
    <!--
 * 横版-首页
 * @LastEditTime: Mon Mar 31 2025 17:10:42 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_7NTW17"  :class="[`normal`,`u_c_7NTW17`]" ><a id="u_c_PZHC67" href="javascript:;" :class="[`normal btn-light`,`u_c_PZHC67`]" @click="u_c_PZHC67_event_8QY427($event)">{{`${ langData.infoBtn }`}}</a><div id="u_c_79Z717"  :class="[`normal`,`u_c_79Z717`]" ></div><div id="u_c_1W8I18"  v-html="compData.title" :class="[`normal`,`u_c_1W8I18`]" ></div><div id="u_c_EM2A17"  :class="[`normal`,`u_c_EM2A17`]" ><div id="u_c_B4QL30"  v-html="compData.eventTime" :class="[`normal`,`u_c_B4QL30`]" ></div></div><div id="u_c_QC8F28"  :class="[`normal`,`u_c_QC8F28`]" ><div id="u_c_W8CG19"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_W8CG19`]" ><div id="u_c_7FNR44"  :class="[`normal txt`,`u_c_7FNR44`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_N0WW69" href="javascript:;" :class="[`normal txt btn`,`u_c_N0WW69`]" @click="u_c_N0WW69_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_EGB531"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_EGB531`]" ><div id="u_c_63WY32"  v-show="pageData.isBind" :class="[`normal txt btn`,`u_c_63WY32`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_I8HJ34"  :class="[`normal`,`u_c_I8HJ34`]" ><a id="u_c_DBFO35" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn `,`u_c_DBFO35`]" @click="u_c_DBFO35_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_6OOA37" href="javascript:;" v-show="pageData.isBind && pageData.canReBind" :class="[`normal txt btn `,`u_c_6OOA37`]" @click="u_c_6OOA37_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_J76039" href="javascript:;" :class="[`normal txt btn `,`u_c_J76039`]" @click="u_c_J76039_event_4DJR33($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_CP2T41" href="javascript:;" :class="[`normal txt btn`,`u_c_CP2T41`]" @click="u_c_CP2T41_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2023年2月28日 ～2023年3月3日23:59`,"title":`2周年庆典`},"zh-CN":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"zh-TW":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"en-US":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"ja-JP":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"ko-KR":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"th-TH":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"vi-VN":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"de-DE":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"fr-FR":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"es-ES":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"pt-PT":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"it-IT":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"tr-TR":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"pl-PL":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"id-ID":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``},"ar-SA":{"eventTime":`Event Duration:2025/4/1 0:00 - 2025/4/15 23:59 (UTC)`,"title":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})

const curPlatform =pagePlatform;

const canClickChange = ref(true);

;
      // 活动规则的click事件
      const u_c_PZHC67_event_8QY427= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_N0WW69_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_DBFO35_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_6OOA37_event_Z75334= async (e)=>{
        try {if(!canClickChange.value)return;

canClickChange.value = false;

const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=resetUserBind`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=resetUserBind`,
  omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=resetUserBind`,
}
let res = await request.getJSON(link[curPlatform])
canClickChange.value = true;

if(res.result!=1){
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName ="";
pageData.serverName = "";
} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_J76039_event_4DJR33= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_CP2T41_event_Q72S64= async (e)=>{
        try {let link = {
  gm99: `https://passport.gm99.com/login/logout2`,
  global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
  omnion: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
}
let res = await request.getJSON(link[curPlatform])
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.default{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.default{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715369121381.png);
background-size:contain;

}
}.default{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715377601284.png);
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.default{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.default{
.u_c_B4QL30.normal{
position:relative;

}
}.default{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.default{
.u_c_W8CG19.normal{
position:relative;

}
}.default{
.u_c_7FNR44.normal{
position:relative;

}
}.default{
.u_c_N0WW69.normal{
position:relative;

}
}.default{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_DBFO35.normal{
position:relative;

}
}.default{
.u_c_6OOA37.normal{
position:relative;

}
}.default{
.u_c_J76039.normal{
position:relative;

}
}.default{
.u_c_CP2T41.normal{
position:relative;

}
}.zh-CN{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.zh-CN{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.zh-CN{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.zh-CN{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.zh-CN{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-CN{
.u_c_B4QL30.normal{
position:relative;

}
}.zh-CN{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.zh-CN{
.u_c_W8CG19.normal{
position:relative;

}
}.zh-CN{
.u_c_7FNR44.normal{
position:relative;

}
}.zh-CN{
.u_c_N0WW69.normal{
position:relative;

}
}.zh-CN{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-CN{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_DBFO35.normal{
position:relative;

}
}.zh-CN{
.u_c_6OOA37.normal{
position:relative;

}
}.zh-CN{
.u_c_J76039.normal{
position:relative;

}
}.zh-CN{
.u_c_CP2T41.normal{
position:relative;

}
}.zh-TW{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.zh-TW{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.zh-TW{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.zh-TW{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.zh-TW{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-TW{
.u_c_B4QL30.normal{
position:relative;

}
}.zh-TW{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.zh-TW{
.u_c_W8CG19.normal{
position:relative;

}
}.zh-TW{
.u_c_7FNR44.normal{
position:relative;

}
}.zh-TW{
.u_c_N0WW69.normal{
position:relative;

}
}.zh-TW{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-TW{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_DBFO35.normal{
position:relative;

}
}.zh-TW{
.u_c_6OOA37.normal{
position:relative;

}
}.zh-TW{
.u_c_J76039.normal{
position:relative;

}
}.zh-TW{
.u_c_CP2T41.normal{
position:relative;

}
}.en-US{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.en-US{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.en-US{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742196420051-4.png);
background-size:contain;

}
}.en-US{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.en-US{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.en-US{
.u_c_B4QL30.normal{
position:relative;

}
}.en-US{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.en-US{
.u_c_W8CG19.normal{
position:relative;

}
}.en-US{
.u_c_7FNR44.normal{
position:relative;

}
}.en-US{
.u_c_N0WW69.normal{
position:relative;

}
}.en-US{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.en-US{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_DBFO35.normal{
position:relative;

}
}.en-US{
.u_c_6OOA37.normal{
position:relative;

}
}.en-US{
.u_c_J76039.normal{
position:relative;

}
}.en-US{
.u_c_CP2T41.normal{
position:relative;

}
}.ja-JP{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1743133314119-44.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ja-JP{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.ja-JP{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103178-21.png);
background-size:contain;

}
}.ja-JP{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ja-JP{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ja-JP{
.u_c_B4QL30.normal{
position:relative;

}
}.ja-JP{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.ja-JP{
.u_c_W8CG19.normal{
position:relative;

}
}.ja-JP{
.u_c_7FNR44.normal{
position:relative;

}
}.ja-JP{
.u_c_N0WW69.normal{
position:relative;

}
}.ja-JP{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ja-JP{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_DBFO35.normal{
position:relative;

}
}.ja-JP{
.u_c_6OOA37.normal{
position:relative;

}
}.ja-JP{
.u_c_J76039.normal{
position:relative;

}
}.ja-JP{
.u_c_CP2T41.normal{
position:relative;

}
}.ko-KR{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ko-KR{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.ko-KR{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.ko-KR{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ko-KR{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ko-KR{
.u_c_B4QL30.normal{
position:relative;

}
}.ko-KR{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.ko-KR{
.u_c_W8CG19.normal{
position:relative;

}
}.ko-KR{
.u_c_7FNR44.normal{
position:relative;

}
}.ko-KR{
.u_c_N0WW69.normal{
position:relative;

}
}.ko-KR{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ko-KR{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_DBFO35.normal{
position:relative;

}
}.ko-KR{
.u_c_6OOA37.normal{
position:relative;

}
}.ko-KR{
.u_c_J76039.normal{
position:relative;

}
}.ko-KR{
.u_c_CP2T41.normal{
position:relative;

}
}.th-TH{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.th-TH{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.th-TH{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.th-TH{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.th-TH{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.th-TH{
.u_c_B4QL30.normal{
position:relative;

}
}.th-TH{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.th-TH{
.u_c_W8CG19.normal{
position:relative;

}
}.th-TH{
.u_c_7FNR44.normal{
position:relative;

}
}.th-TH{
.u_c_N0WW69.normal{
position:relative;

}
}.th-TH{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.th-TH{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_DBFO35.normal{
position:relative;

}
}.th-TH{
.u_c_6OOA37.normal{
position:relative;

}
}.th-TH{
.u_c_J76039.normal{
position:relative;

}
}.th-TH{
.u_c_CP2T41.normal{
position:relative;

}
}.vi-VN{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.vi-VN{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.vi-VN{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.vi-VN{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.vi-VN{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.vi-VN{
.u_c_B4QL30.normal{
position:relative;

}
}.vi-VN{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.vi-VN{
.u_c_W8CG19.normal{
position:relative;

}
}.vi-VN{
.u_c_7FNR44.normal{
position:relative;

}
}.vi-VN{
.u_c_N0WW69.normal{
position:relative;

}
}.vi-VN{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.vi-VN{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_DBFO35.normal{
position:relative;

}
}.vi-VN{
.u_c_6OOA37.normal{
position:relative;

}
}.vi-VN{
.u_c_J76039.normal{
position:relative;

}
}.vi-VN{
.u_c_CP2T41.normal{
position:relative;

}
}.de-DE{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.de-DE{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.de-DE{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.de-DE{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.de-DE{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.de-DE{
.u_c_B4QL30.normal{
position:relative;

}
}.de-DE{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.de-DE{
.u_c_W8CG19.normal{
position:relative;

}
}.de-DE{
.u_c_7FNR44.normal{
position:relative;

}
}.de-DE{
.u_c_N0WW69.normal{
position:relative;

}
}.de-DE{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.de-DE{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_DBFO35.normal{
position:relative;

}
}.de-DE{
.u_c_6OOA37.normal{
position:relative;

}
}.de-DE{
.u_c_J76039.normal{
position:relative;

}
}.de-DE{
.u_c_CP2T41.normal{
position:relative;

}
}.fr-FR{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.fr-FR{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.fr-FR{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.fr-FR{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.fr-FR{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.fr-FR{
.u_c_B4QL30.normal{
position:relative;

}
}.fr-FR{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.fr-FR{
.u_c_W8CG19.normal{
position:relative;

}
}.fr-FR{
.u_c_7FNR44.normal{
position:relative;

}
}.fr-FR{
.u_c_N0WW69.normal{
position:relative;

}
}.fr-FR{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.fr-FR{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_DBFO35.normal{
position:relative;

}
}.fr-FR{
.u_c_6OOA37.normal{
position:relative;

}
}.fr-FR{
.u_c_J76039.normal{
position:relative;

}
}.fr-FR{
.u_c_CP2T41.normal{
position:relative;

}
}.es-ES{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.es-ES{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.es-ES{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.es-ES{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.es-ES{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.es-ES{
.u_c_B4QL30.normal{
position:relative;

}
}.es-ES{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.es-ES{
.u_c_W8CG19.normal{
position:relative;

}
}.es-ES{
.u_c_7FNR44.normal{
position:relative;

}
}.es-ES{
.u_c_N0WW69.normal{
position:relative;

}
}.es-ES{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.es-ES{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_DBFO35.normal{
position:relative;

}
}.es-ES{
.u_c_6OOA37.normal{
position:relative;

}
}.es-ES{
.u_c_J76039.normal{
position:relative;

}
}.es-ES{
.u_c_CP2T41.normal{
position:relative;

}
}.pt-PT{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.pt-PT{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.pt-PT{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.pt-PT{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.pt-PT{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pt-PT{
.u_c_B4QL30.normal{
position:relative;

}
}.pt-PT{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.pt-PT{
.u_c_W8CG19.normal{
position:relative;

}
}.pt-PT{
.u_c_7FNR44.normal{
position:relative;

}
}.pt-PT{
.u_c_N0WW69.normal{
position:relative;

}
}.pt-PT{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pt-PT{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_DBFO35.normal{
position:relative;

}
}.pt-PT{
.u_c_6OOA37.normal{
position:relative;

}
}.pt-PT{
.u_c_J76039.normal{
position:relative;

}
}.pt-PT{
.u_c_CP2T41.normal{
position:relative;

}
}.it-IT{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.it-IT{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.it-IT{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.it-IT{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.it-IT{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.it-IT{
.u_c_B4QL30.normal{
position:relative;

}
}.it-IT{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.it-IT{
.u_c_W8CG19.normal{
position:relative;

}
}.it-IT{
.u_c_7FNR44.normal{
position:relative;

}
}.it-IT{
.u_c_N0WW69.normal{
position:relative;

}
}.it-IT{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.it-IT{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_DBFO35.normal{
position:relative;

}
}.it-IT{
.u_c_6OOA37.normal{
position:relative;

}
}.it-IT{
.u_c_J76039.normal{
position:relative;

}
}.it-IT{
.u_c_CP2T41.normal{
position:relative;

}
}.tr-TR{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.tr-TR{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.tr-TR{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.tr-TR{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.tr-TR{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.tr-TR{
.u_c_B4QL30.normal{
position:relative;

}
}.tr-TR{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.tr-TR{
.u_c_W8CG19.normal{
position:relative;

}
}.tr-TR{
.u_c_7FNR44.normal{
position:relative;

}
}.tr-TR{
.u_c_N0WW69.normal{
position:relative;

}
}.tr-TR{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.tr-TR{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_DBFO35.normal{
position:relative;

}
}.tr-TR{
.u_c_6OOA37.normal{
position:relative;

}
}.tr-TR{
.u_c_J76039.normal{
position:relative;

}
}.tr-TR{
.u_c_CP2T41.normal{
position:relative;

}
}.pl-PL{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.pl-PL{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.pl-PL{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.pl-PL{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.pl-PL{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pl-PL{
.u_c_B4QL30.normal{
position:relative;

}
}.pl-PL{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.pl-PL{
.u_c_W8CG19.normal{
position:relative;

}
}.pl-PL{
.u_c_7FNR44.normal{
position:relative;

}
}.pl-PL{
.u_c_N0WW69.normal{
position:relative;

}
}.pl-PL{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pl-PL{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_DBFO35.normal{
position:relative;

}
}.pl-PL{
.u_c_6OOA37.normal{
position:relative;

}
}.pl-PL{
.u_c_J76039.normal{
position:relative;

}
}.pl-PL{
.u_c_CP2T41.normal{
position:relative;

}
}.id-ID{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.id-ID{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.id-ID{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.id-ID{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.id-ID{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.id-ID{
.u_c_B4QL30.normal{
position:relative;

}
}.id-ID{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.id-ID{
.u_c_W8CG19.normal{
position:relative;

}
}.id-ID{
.u_c_7FNR44.normal{
position:relative;

}
}.id-ID{
.u_c_N0WW69.normal{
position:relative;

}
}.id-ID{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.id-ID{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_DBFO35.normal{
position:relative;

}
}.id-ID{
.u_c_6OOA37.normal{
position:relative;

}
}.id-ID{
.u_c_J76039.normal{
position:relative;

}
}.id-ID{
.u_c_CP2T41.normal{
position:relative;

}
}.ar-SA{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191684391-6.png);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ar-SA{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.54vw;
top:1.98vw;
right:1.41vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012043091-39.png);
display:flex;
align-items:center;
font-size:1.09vw;
color:#f2f2f2;
text-decoration:none;
justify-content:center;
text-align:center;
z-index:6;

}
}.ar-SA{
.u_c_79Z717.normal{
position:absolute;
width:19.53vw;
height:4.22vw;
top:0.83vw;
right:29.38vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732502103184-66.png);
background-size:contain;

}
}.ar-SA{
.u_c_1W8I18.normal{
position:absolute;
width:56.25vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
top:13.65vw;
left:20.52vw;
font-size:4.17vw;
color:#a5fdfc;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ar-SA{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649235538215.png);
margin:auto;
margin-top:37.97vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.99vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ar-SA{
.u_c_B4QL30.normal{
position:relative;

}
}.ar-SA{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:0.10vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.04vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.ar-SA{
.u_c_W8CG19.normal{
position:relative;

}
}.ar-SA{
.u_c_7FNR44.normal{
position:relative;

}
}.ar-SA{
.u_c_N0WW69.normal{
position:relative;

}
}.ar-SA{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ar-SA{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_DBFO35.normal{
position:relative;

}
}.ar-SA{
.u_c_6OOA37.normal{
position:relative;

}
}.ar-SA{
.u_c_J76039.normal{
position:relative;

}
}.ar-SA{
.u_c_CP2T41.normal{
position:relative;

}
}
</style>
